import OpenImageContainer from '../containers/mx/OpenImageContainer';

export const MODAL_TYPE = {
    OPEN_IMAGE: 'OPEN_IMAGE'
};

export const MODAL_COMPONENTS = {
    OPEN_IMAGE: OpenImageContainer
};